import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e0d73a2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0d73a2')) {
      api.createRecord('2e0d73a2', component.options)
    } else {
      api.reload('2e0d73a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e0d73a2&", function () {
      api.rerender('2e0d73a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_legal-entity/index.vue"
export default component.exports